import {useEffect} from 'react'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const usePostAccountStoreTicketGive = (
	accountIdx,
	numberAmount,
	voucherTypeIdx,
	isRef = true
) => {
	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()
	const [userRole] = useRoleCookie()

	const clickEvent = () => {
		if (!accountIdx) {
			setAlert('지급할 사용자를 선택해 주세요.')
			return
		}

		const number = isRef ? numberAmount?.current?.value : numberAmount
		if (
			!number ||
			number.trim() === '' ||
			parseInt(number) <= 0 ||
			isNaN(parseInt(number))
		) {
			setAlert('지급할 개수를 올바르게 입력해 주세요.')
			return
		}

		const voucherType = isRef ? voucherTypeIdx?.current?.value : voucherTypeIdx
		if (!voucherType || voucherType === '') {
			setAlert('매장 이용권 유형을 선택해 주세요.')
			return
		}
		const rolePath = getApiRolePath(userRole)

		fetchRequest(
			'POST',
			`/${rolePath}/store/account/${accountIdx}/ticket-by-type`,
			{
				number: parseInt(number),
				ticket_type_idx: parseInt(voucherType),
			}
		)
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				window.location.reload()
				break
			case 400:
				if (fetchResult?.data?.error_code === 'account_idx')
					setAlert('사용자 계정 idx 입력 양식을 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'number')
					setAlert('개수 입력 양식을 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'ticket_type_idx')
					setAlert('매장 이용권 유형을 확인해 주세요.')
				else if (fetchResult?.data?.message)
					setAlert(fetchResult?.data?.message)
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1) {
					setAlert('계정 데이터가 존재하지 않습니다.')
				} else if (fetchResult?.data?.error_code === 2) {
					setAlert('선택한 매장 이용권 유형이 존재하지 않습니다.')
				} else {
					setAlert('지급할 수 있는 이용권이 존재하지 않습니다.')
				}
				break
			default:
				break
		}
	}, [fetchResult])

	return [clickEvent]
}

export default usePostAccountStoreTicketGive
